// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Shared Rules Tab content styles
 *
 * All campaign rules tabs render the same shell: bold section titles,
 * bullet lists and yellow highlighted values. Each variant module
 * composes the classes it uses from here and declares only what differs.
 */
.Kx_lSu6vjfndOw5cG6_7 {
  font-weight: bold;
}
.JZUf2a6wyAvja5uhQgPq:first-child > .Kx_lSu6vjfndOw5cG6_7 {
  margin-top: -7px;
}
.sPFGzWOaH7LrILq8y0eR {
  font-weight: bold;
  color: #ffdf1a;
}
.vySsPvcapUzvgK9DWmzd {
  list-style-type: disc;
  padding-left: 1.25rem;
  margin: 0;
}
.FtQGcj2vAkog0oXsQxcW {
  margin-bottom: 0;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .JZUf2a6wyAvja5uhQgPq:first-child > .Kx_lSu6vjfndOw5cG6_7 {
    margin-top: -4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/tabs/RulesTab/css/base/RulesContent.base.module.css"],"names":[],"mappings":"AAAA;;;;;;EAME;AACF;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/**\n * Shared Rules Tab content styles\n *\n * All campaign rules tabs render the same shell: bold section titles,\n * bullet lists and yellow highlighted values. Each variant module\n * composes the classes it uses from here and declares only what differs.\n */\n.title {\n  font-weight: bold;\n}\n.section:first-child > .title {\n  margin-top: -7px;\n}\n.highlightedText {\n  font-weight: bold;\n  color: #ffdf1a;\n}\n.list {\n  list-style-type: disc;\n  padding-left: 1.25rem;\n  margin: 0;\n}\n.listItem {\n  margin-bottom: 0;\n}\n@media (--campaign-mobile) {\n  .section:first-child > .title {\n    margin-top: -4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Kx_lSu6vjfndOw5cG6_7`,
	"section": `JZUf2a6wyAvja5uhQgPq`,
	"highlightedText": `sPFGzWOaH7LrILq8y0eR`,
	"list": `vySsPvcapUzvgK9DWmzd`,
	"listItem": `FtQGcj2vAkog0oXsQxcW`
};
export default ___CSS_LOADER_EXPORT___;
